import { FileType } from '../../enums/FileType';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { Location } from '../models/Location';
import { LocationValue } from '../models/valueObjects/LocationValue';

export class LocationMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Location {
    /*
     * Notes on the locationValue fields:
     * - Even though fields location.path, location.hostname, and location.fileType can potentially be null,
     *   an error will be raised from the backend before reaching this point.
     *
     * - These fields might only be null if the location type isn't "fileSystem".
     *   As of now, the backend only provides a parser specifically for the "fileSystem" location type.
     *   It means an error will be raised when we specify a different "type" or any field will be missing
     */
    const locationValue = new LocationValue(data.path, data.hostname, data.fileType ?? FileType.UNKNOWN, data.imageInfo, data.imageType);
    return new Location(this.gqlIdEncoder.decode(data.id), locationValue);
  }
}
